










































import { mapGetters } from 'vuex'
import Vue from 'vue'
export default Vue.extend({
    computed: {
        ...mapGetters(['tenant']),
        dataProviders(): object[] {
            return [
                {
                    name: 'QuickBooks Online',
                    image: 'qboCircle',
                    link: '/qbo',
                    hidden: this.tenant.data_provider == 'CSV'
                },
                {
                    name: 'Sphere Payments',
                    image: 'sphereLogo',
                    link: '/sphere',
                    hidden: false
                },
                {
                    name: 'Xero',
                    image: 'xeroLogo',
                    link: '/xero',
                    hidden: this.tenant.data_provider == 'CSV'
                }
            ]
        }
    }
})
